import actionConstant from './actionConstant';

export function openToast(data) {
    return { type: actionConstant.OPEN_TOASTER, payload: data };
}

export function closeToast() {
    return { type: actionConstant.CLOSE_TOASTER };
}

export function clearToast() {
    return { type: actionConstant.CLEAR_TOASTER };
}
